export const VALIDATE_EMAIL_CODE = {
    REQUIRED: 'required',
    INVALID: 'invalid',
    UNKNOW: 'unknow',
    MAX_LENGTH: 'maxLength',
    VALID: 'valid'
}

export const VALIDATE_DESCRIPTION_CODE = {
    UNKNOW: 'unknow',
    MAX_LENGTH: 'maxLength',
    VALID: 'valid'
}

export const BLACK_LIST = [
    '0123', '1234', '2345', '3456', 
    '4567', '5678', '6789',
    '123456aA@', '1234567aA@', '12345678aA@',
    '123456789aA@', '12345', '123456',
    '1234567', '12345678', '123456789',
    '111111a@', 'Password@123', 'root@2014',
    '111111A@', 'Password@1234', 'root@2015',
    '111111@a', 'Password@2010', 'root@2016',
    '111111@A', 'Password@2011', 'root@2017',
    '123456a@', 'Password@2012', 'Root@123',
    '123456A@', 'Password@2013', 'Root@1234',
    '123456@a', 'Password@2014', 'Root@2010',
    '123456@A', 'Password@2015', 'Root@2011',
    'admin@123', 'Password@2016', 'Root@2012',
    'admin@1234', 'Password@2017', 'Root@2013',
    'admin@2010', 'passw0rda@', 'Root@2014',
    'admin@2011', 'passw0rdA@', 'Root@2015',
    'admin@2012', 'passw0rd@123', 'Root@2016',
    'admin@2013', 'passw0rd@1234', 'Root@2017',
    'admin@2014', 'passw0rd@2010', 'r00t@123',
    'admin@2015', 'passw0rd@2011', 'r00t@1234',
    'admin@2016', 'passw0rd@2012', 'r00t@2010',
    'admin@2017', 'passw0rd@2013', 'r00t@2011',
    'Admin@123', 'passw0rd@2014', 'r00t@2012',
    'Admin@1234', 'passw0rd@2015', 'r00t@2013',
    'Admin@2010', 'passw0rd@2016', 'r00t@2014',
    'Admin@2011', 'passw0rd@2017', 'r00t@2015',
    'Admin@2012', 'passw0rd@a', 'r00t@2016',
    'Admin@2013', 'passw0rd@A', 'r00t@2017',
    'Admin@2014', 'qwerty@123', 'R00t@123',
    'Admin@2015', 'qwerty@1234', 'R00t@1234',
    'Admin@2016', 'qwerty@2010', 'R00t@2010',
    'Admin@2017', 'qwerty@2011', 'R00t@2011',
    'viettel@123', 'qwerty@2012', 'R00t@2012',
    'viettel@1234', 'qwerty@2013', 'R00t@2013',
    'viettel@2010', 'qwerty@2014', 'R00t@2014',
    'viettel@2011', 'qwerty@2015', 'R00t@2015',
    'viettel@2012', 'qwerty@2016', 'R00t@2016',
    'viettel@2013', 'qwerty@2017', 'R00t@2017',
    'viettel@2014', 'abc123a@', 'qazwsx@123',
    'viettel@2015', 'abc123A@', 'qazwsx@1234',
    'viettel@2016', 'abc123@123', 'qazwsx@2010',
    'viettel@2017', 'abc123@1234', 'qazwsx@2011',
    'Viettel@123', 'abc123@2010', 'qazwsx@2012',
    'Viettel@1234', 'abc123@2011', 'qazwsx@2013',
    'Viettel@2010', 'abc123@2012', 'qazwsx@2014',
    'Viettel@2011', 'abc123@2013', 'qazwsx@2015',
    'Viettel@2012', 'abc123@2014', 'qazwsx@2016',
    'Viettel@2013', 'abc123@2015', 'qazwsx@2017',
    'Viettel@2014', 'abc123@2016', '123qwea@',
    'Viettel@2015', 'abc123@2017', '123qweA@',
    'Viettel@2016', 'abc123@a', '123qwe@123',
    'Viettel@2017', 'abc123@A', '123qwe@1234',
    'password@123', '123123a@', '123qwe@2010',
    'password@1234', '123123A@', '123qwe@2011',
    'password@2010', '123123@a', '123qwe@2012',
    'password@2011', '123123@A', '123qwe@2013',
    'password@2012', 'root@123', '123qwe@2014',
    'password@2013', 'root@1234', '123qwe@2015',
    'password@2014', 'root@2010', '123qwe@2016',
    'password@2015', 'root@2011', '123qwe@2017',
    'password@2016', 'root@2012', '123qwe@a',
    'password@2017', 'root@2013', '123qwe@A'
]